import { MutationTree, Module } from 'vuex';
import { v1 as uuid } from 'uuid';
import { RootState } from './types';

export enum ToastType {
  SUCCESS = 'success',
  FAILED = 'failed'
}

export interface Toast {
  id?: string;
  title: string;
  message: string;
  type: ToastType;
}

type State = {
  toasts: Toast[];
}

export enum MutationTypes {
  ADD_TOAST = 'ADD_TOAST',
  REMOVE_TOAST = 'REMOVE_TOAST',
}

const states: State = {
  toasts: [],
};

export type Mutations<S = State> = {
  [MutationTypes.ADD_TOAST](state: S, payload: Toast): void;
  [MutationTypes.REMOVE_TOAST](state: S, id: string): void;
}

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.ADD_TOAST](state, payload: Toast) {
    const toast = {
      ...payload,
      id: uuid(),
    };
    state.toasts.push(toast);
  },
  [MutationTypes.REMOVE_TOAST](state, id: string) {
    const index = state.toasts.findIndex((e) => e.id === id);
    state.toasts.splice(index, 1);
  },
};

const toastModule: Module<State, RootState> = {
  state: states,
  mutations,
};

export default toastModule;
